module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.current) ? _c('div', {
    staticClass: "flex-grid flex-state-buttons c-claim-header"
  }, [_c('quantum-icons'), _vm._v(" "), _c('h2', {
    staticClass: "u-d-inline-block u-float-l u-margin-right-10"
  }, [_c('span', {
    staticClass: "claim-title"
  }, [_vm._v(_vm._s(_vm.humanClaimType) + ": ")]), _vm._v(_vm._s(_vm.pageTitle) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-position-relative c-claim-header__right"
  }, [(!_vm.isFinalStep) ? _c('button', {
    staticClass: "svg_button u-float-l c-icon-tooltip u-r-full-width u-r-d-flex",
    class: {
      'm-icon--disabled': !_vm.current.valid, 'm-icon--save': _vm.current.valid
    },
    on: {
      "click": _vm.saveForm
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small u-d-inline-block",
    class: [!_vm.current.valid ? 'm-icon--save-hover' : ''],
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#save"
    }
  })]), _vm._v(" "), (_vm.tooltipVisible && _vm.current.valid || _vm.current.valid && _vm.theCurrentWidth <= 1024) ? _c('div', {
    staticClass: "c-icon-tooltip__text c-icon-tooltip__bottom"
  }, [_vm._v("\n                    Save claim progress\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tooltipVisible && !_vm.current.valid || !_vm.current.valid && _vm.theCurrentWidth <= 1024) ? _c('div', {
    staticClass: "c-icon-tooltip__text c-icon-tooltip__bottom"
  }, [_vm._v("\n                    Cannot save until all step data is valid\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.saving()) ? _c('div', {
    staticClass: "a-loader u-float-l u-d-inline-block a-loader--save-icon"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-claim-header__timeline-text m-hide-timeline",
    class: {
      'm-hide-timeline--closed': _vm.isTimelineOpen
    },
    on: {
      "click": _vm.updateTimeline
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.timelineText))])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTimelineOpen),
      expression: "isTimelineOpen"
    }],
    staticClass: "m-timeline"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDocumentView),
      expression: "!isDocumentView"
    }],
    staticClass: "m-timeline__progress",
    class: 'm-timeline__progress--' + _vm.timelineSteps
  }, _vm._l((_vm.steps), function(step, index) {
    return (step.route.meta.step <= 9) ? _c('router-link', {
      class: {
        'm-timeline__progress--active': index <= _vm.stepNo && !_vm.progressInvalid(index, step),
          'm-timeline__progress--disabled': !_vm.progressAllowed(index, step),
          'm-timeline__progress--error': _vm.progressInvalid(index, step)
      },
      attrs: {
        "tag": "li",
        "to": _vm.route(step),
        "active-class": "m-timeline__progress--active"
      }
    }, [_c('span', [_vm._v(_vm._s(step.name))])]) : _vm._e()
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c7c0003!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline.vue
// module id = 1681
// module chunks = 0